// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__14Nai","colMin":"styles_colMin__E_ScO"};